import type { ModifyBadgesResult } from 'commonTypes/api/scenarios/BaseTypes';

export const addAdditionalBadges = (badges: ModifyBadgesResult, description?: string): ModifyBadgesResult => {
  if (description) {
    badges.push({
      text: 'можно забирать деньги',
      color: 'green',
      variant: 'primary',
      tooltipContent: description,
    });
  }

  return badges;
};
